import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { SetMeal, PendingActions, Assignment } from "@mui/icons-material";

// Casca compartilhada das telas de Espécies (SYNCORP-912, Task 3) — mesmo
// padrão do GeografiaLayout (Locais/Áreas): 1 item no sidebar, abas no topo
// pra trocar entre Espécies, Pendências e Catálogo por Projeto.
const EspeciesLayout = () => {
  const abas = [
    { name: 'Espécies', path: '/admin/especies', icon: <SetMeal fontSize="small" />, end: true },
    { name: 'Pendências', path: '/admin/especies/pendencias', icon: <PendingActions fontSize="small" />, end: true },
    { name: 'Catálogo por Projeto', path: '/admin/especies/catalogo', icon: <Assignment fontSize="small" />, end: true },
  ];

  return (
    <div style={{ width: '100%' }}>
      <div style={tabBarWrapStyle}>
        <div style={tabBarStyle}>
          {abas.map((aba) => (
            <NavLink
              key={aba.path}
              to={aba.path}
              end={aba.end}
              style={({ isActive }) => ({ ...tabStyle, ...(isActive ? tabActiveStyle : {}) })}
            >
              {aba.icon}
              {aba.name}
            </NavLink>
          ))}
        </div>
      </div>
      <div style={{ minHeight: '78vh' }}>
        <Outlet />
      </div>
    </div>
  );
};

const tabBarWrapStyle: React.CSSProperties = {
  width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '20px 20px 0',
};
const tabBarStyle: React.CSSProperties = {
  display: 'flex', gap: '4px', borderBottom: '1px solid #e2e2e2', flexWrap: 'wrap',
};
const tabStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: '6px',
  padding: '10px 16px', fontSize: '0.88rem', color: '#666', textDecoration: 'none',
  borderBottom: '2px solid transparent', marginBottom: '-1px', whiteSpace: 'nowrap',
};
const tabActiveStyle: React.CSSProperties = {
  color: 'var(--green-700, #00b37e)', borderBottomColor: 'var(--green-700, #00b37e)', fontWeight: 600,
};

export default EspeciesLayout;
